import { FC } from 'react'
import { SiteModel } from '../../../core/_models'
type Props = {
  site: SiteModel
}
const TenderLaunchRelaunch: FC<Props> = ({ site }) => {

  var formattedDate = '';

  if(site.tenderLaunchRelaunch != null || site.tenderLaunchRelaunch != undefined){
     formattedDate = site.tenderLaunchRelaunch === '0001-01-01T00:00:00' ? '' : new Date(site.tenderLaunchRelaunch).toLocaleDateString('tr-TR');
  }

  return (
    <div className='d-flex align-items-center'>
      {formattedDate}
    </div>
  )
}
export { TenderLaunchRelaunch }
